<wiz-hgroup #argContainer width="100%" height="100%">

  <wiz-hgroup #freeGrp [visible]="usefreeGrp"  width="100%" height="100%">
    <angular-editor #ae width="100%" height="100%" style="pointer-events: none;"></angular-editor>
  </wiz-hgroup>

  <wiz-hgroup #freeImgGrp *ngIf="usefreeImgGrp" width="100%" height="100%">
    <wiz-image
        #freeImg
        [sourceObservable]="imgSrcObs"
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <wiz-button #bt *ngIf="usebt"
  class="button-connect"
  [wizLabel]="cnx?.trsLabel"
  [tooltipText]="cnx?.trsDescription"
  [wizImage]="cnx?.iconOrDie"
  width="100%" (wizClick)="doArgAction()"></wiz-button>
 
  <!-- zone de drop -->
  <wiz-vgroup  #dropGrp *ngIf="useDropGrp" class="dropZone" width="100%" height="100%" horizontalAlign="center" verticalAlign="center"
  (click)="selectFile()" (drop)="dropFile($event)" (dragover)="dover($event)">
    <wiz-icon [wizTooltip]="'$.common.import.$'">upload</wiz-icon>
    <wiz-label wizLabel="$.common.free.drop.message.$"></wiz-label>
  </wiz-vgroup>


</wiz-hgroup>
